import { createContext } from 'react'

import { IActions } from 'actions/global'

import { IGlobalState, initialState } from '../types/context'

export const GlobalContext = createContext<{globalState:IGlobalState; globalDispatch: React.Dispatch<IActions>}>({globalState: initialState, globalDispatch:() => null})